import React from "react";
import PrintIcon from '@mui/icons-material/Print';
import Box from '@mui/material/Box';
export default function PrintPage() {
return (

    <Box sx={{ display: 'block', displayPrint: 'none' }}>
       <PrintIcon onClick={() => window.print()} style={{position: 'fixed', bottom: '10px', right: '10px', fontSize: '50px', color: 'grey', cursor:'pointer', displayPrint: 'none'  }}/>
    </Box>

);
}